// extracted by mini-css-extract-plugin
export default {"shortInfo":"shortInfo-module__shortInfo__F8pvi","shortInfoMobileShadow":"shortInfo-module__shortInfoMobileShadow__zk+My","button":"shortInfo-module__button__oFDQT"};